import {
  BrandConfig,
  BrandId,
  DEFAULT_BRAND_ID,
  getBrandById,
  resolveBrand,
} from '@ui/config/brand';
import { createContext, useContext, useMemo } from 'react';

const BrandContext = createContext<BrandConfig>(getBrandById(DEFAULT_BRAND_ID));

const getClientBrand = () => {
  if (typeof window === 'undefined') return getBrandById(DEFAULT_BRAND_ID);

  return resolveBrand({
    host: window.location.host,
    brandIdFromEnv: process.env.NEXT_PUBLIC_BRANDING_ID,
  });
};

export const BrandProvider = ({
  brandId,
  children,
}: {
  brandId?: BrandId;
  children: React.ReactNode;
}) => {
  const brand = useMemo(() => {
    if (brandId) return getBrandById(brandId);

    return getClientBrand();
  }, [brandId]);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};

export const useBrand = () => useContext(BrandContext);

